import script from "./TeamsQuickMeet.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamsQuickMeet.vue?vue&type=script&setup=true&lang=js"

import "./TeamsQuickMeet.vue?vue&type=style&index=0&id=522687ac&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522687ac"]])

export default __exports__